/**
 * Transforms the table state into the proper query variables set
 * @param {Object} params
 * @param forceWhere
 * @param args
 */
export const paramsToListQueryInput = (params, forceWhere = {}, args = {}) => {
  const orderBy = !params.sortBy
    ? {}
    : { orderBy: `${params.sortBy[0].field}_${params.sortBy[0].dir.toUpperCase()}` }
  const where = !params.filters
    ? {}
    : {
      where: Object.entries(params.filters).reduce((acc, [field, conditions]) => {
        if (field === 'primaryCategory.title') {
          Object.entries(conditions).forEach(([modifier, value]) => {
            acc.primaryCategory = {}
            const fileName = `title_${modifier}`
            acc.primaryCategory[fileName] = value
          })
        } else if (field === 'city.title') {
          Object.entries(conditions).forEach(([modifier, value]) => {
            acc.city = {}
            const fileName = `title_${modifier}`
            acc.city[fileName] = value
          })
        } else if (field === 'place.title') {
          Object.entries(conditions).forEach(([modifier, value]) => {
            acc.place = {}
            const fileName = `title_${modifier}`
            acc.place[fileName] = value
          })
        } else if (field === 'translations') {
          acc.translations = {
            [conditions.equals]: {
              isEnabled: true
            }
          }
        } else if (field === 'profileName' || field === 'profileType') {
          Object.entries(conditions).forEach(([modifier, value]) => {
            if (field === 'profileName') {
              field = 'name'
            } else if (field === 'profileType') {
              field = 'type'
            }
            const fieldName = modifier === 'equals' ? field : `${field}_${modifier}`
            acc.profile = { ...acc.profile, [fieldName]: value }
          })
        } else if (field === 'id') {
          Object.entries(conditions).forEach(([modifier, value]) => {
            const fieldName = modifier === 'equals' ? field : `${field}_${modifier}`
            acc[fieldName] = +value
          })
        } else {
          Object.entries(conditions).forEach(([modifier, value]) => {
            const fieldName = modifier === 'equals' ? field : `${field}_${modifier}`
            acc[fieldName] = value
          })
        }
        return acc
      }, {})
    }
  return {
    skip: (params.page - 1) * params.perPage,
    limit: params.perPage,
    ...orderBy,
    where: { ...where.where, ...forceWhere },
    ...args
  }
}
